import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import logo from "../assets/logo.png";

const Home = () => {
	const navigate = useNavigate();
	const [tower, setTower] = useState("");
	const [unit, setUnit] = useState("");
	const [vehicle, setVehicle] = useState("");
	const [plate, setPlate] = useState("");
	const [msisdn, setMsisdn] = useState("");
	const [purpose, setPurpose] = useState("");
	const [errorMessage, setErrorMessage] = useState("");

	const [towerError, setTowerError] = useState(false);
	const [unitError, setUnitError] = useState(false);
	const [vehicleError, setVehicleError] = useState(false);
	const [plateError, setPlateError] = useState(false);
	const [msisdnError, setMsisdnError] = useState(false);
	const [purposeError, setPurposeError] = useState(false);

	const [loading, setLoading] = useState(false);
	const [fetching, setFetching] = useState(false);

	const createTransaction = async (e) => {
		e.preventDefault();
		setLoading(true);
		setTowerError(false);
		setUnitError(false);
		setVehicleError(false);
		setPlateError(false);
		setMsisdnError(false);
		setPurposeError(false);
		setErrorMessage("");
		if (validate() === true) {
			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					client_id: 1,
					tower: tower,
					unit: unit,
					vehicle: vehicle,
					plate_no: plate,
					msisdn: msisdn,
					purpose: purpose,
				}),
			};

			const response = await fetch(
				`${process.env.REACT_APP_API_URI}/transactions/`,
				requestOptions
			);
			const data = await response.json();

			if (!response.ok) {
				setErrorMessage(data.msg);
			} else {
				navigate(`/qr/entry/${data.transaction_id}`);
			}
		}
		setLoading(false);
	};

	const validate = () => {
		if (!tower || !unit || !vehicle || !plate || !msisdn || !purpose) {
			setErrorMessage("Please fill out all required fields.");
			if (!tower) {
				setTowerError(true);
			}
			if (!unit) {
				setUnitError(true);
			}
			if (!vehicle) {
				setVehicleError(true);
			}
			if (!plate) {
				setPlateError(true);
			}
			if (!msisdn) {
				setMsisdnError(true);
			}
			if (!purpose) {
				setPurposeError(true);
			}
			return false;
		} else {
			if (msisdn.slice(0, 2) !== "09" || msisdn.length !== 11) {
				setErrorMessage("Invalid mobile number format.");
				setMsisdnError(true);
				return false;
			} else {
				return true;
			}
		}
	};

	const fetchSuggestion = async () => {
		setFetching(true);
		setTowerError(false);
		setUnitError(false);
		setVehicleError(false);
		setPlateError(false);
		setMsisdnError(false);
		setPurposeError(false);
		setErrorMessage("");
		const requestOptions = {
			method: "GET",
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/transactions/suggestions/${msisdn}`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			setErrorMessage(data.msg);
		} else {
			setVehicle(data.transaction.vehicle);
			setPlate(data.transaction.plate_no);
			setPurpose(data.transaction.purpose);
		}
		setFetching(false);
	};

	useEffect(() => {
		if (msisdn.slice(0, 2) === "09" || msisdn.length === 11) {
			fetchSuggestion();
		}
	}, [msisdn]);

	return (
		<>
			<div className="guest-content full-page full">
				<Container>
					<div className="form-container flex-column full-page">
						<Form
							onSubmit={createTransaction}
							className="input-form bg-white rounded col-lg-5 col-md-8 col-12"
						>
							<div className="align-center mb-4">
								<img src={logo} alt="logo" className="home-logo" />
								<span className="home-brand text-xl block text-bold-inter">
									<span className="text-green">FAST</span>PASS
								</span>
								{/* <span>By Condopal</span> */}
							</div>
							<Row className="form-block">
								<Col>
									<Form.Label>Mobile Number</Form.Label>
									<Form.Control
										className={`form-input rounded ${msisdnError && "error"}`}
										placeholder="Enter mobile number"
										value={msisdn}
										onChange={(e) => setMsisdn(e.target.value)}
									/>
								</Col>
							</Row>
							<Row className="form-block">
								<Col>
									<Form.Label>Vehicle Make & Model</Form.Label>
									<Form.Control
										className={`form-input rounded ${vehicleError && "error"}`}
										placeholder="Enter vehicle make & model"
										value={vehicle}
										onChange={(e) => setVehicle(e.target.value)}
									/>
								</Col>
							</Row>
							<Row className="form-block">
								<Col>
									<Form.Label>Plate Number</Form.Label>
									<Form.Control
										className={`form-input rounded ${plateError && "error"}`}
										placeholder="Enter plate number"
										value={plate}
										onChange={(e) => setPlate(e.target.value)}
									/>
								</Col>
							</Row>
							<Row className="form-block">
								<Col>
									<Form.Label>Purpose of Visit</Form.Label>
									<Form.Select
										className={`form-input rounded ${purposeError && "error"}`}
										value={purpose}
										onChange={(e) => setPurpose(e.target.value)}
									>
										<option value="">Select purpose of visit</option>
										<option value="Delivery">Delivery</option>
										<option value="Official Business">Official Business</option>
										<option value="Visit">Visit</option>
									</Form.Select>
								</Col>
							</Row>
							<Row className="form-block">
								<Col>
									<Form.Label>Tower To Visit</Form.Label>
									<Form.Select
										className={`form-input rounded ${towerError && "error"}`}
										value={tower}
										onChange={(e) => setTower(e.target.value)}
									>
										<option value="">Select tower to visit</option>
										<option value="Bahamas">Bahamas</option>
										<option value="Boracay">Boracay</option>
										<option value="Miami">Miami</option>
										<option value="Maldives">Maldives</option>
										<option value="Maui">Maui</option>
										<option value="Positano">Positano</option>
										<option value="Rio East">Rio East</option>
										<option value="Rio West">Rio West</option>
										<option value="Santorini">Santorini</option>
										<option value="St. Tropez">St. Tropez</option>
									</Form.Select>
								</Col>
							</Row>
							<Row className="form-block">
								<Col>
									<Form.Label>Unit To Visit</Form.Label>
									<Form.Control
										className={`form-input rounded ${unitError && "error"}`}
										placeholder="Enter unit to visit"
										value={unit}
										onChange={(e) => setUnit(e.target.value)}
									/>
								</Col>
							</Row>
							{errorMessage && (
								<Row className="form-block">
									<Col>
										<span className="form-error-msg text-red">
											{errorMessage}
										</span>
									</Col>
								</Row>
							)}
							<Row>
								<Col>
									<Button
										type="submit"
										className="btn-default rounded full btn-lg upper text-medium-inter text-md"
										disabled={loading}
									>
										{loading ? "Submitting" : "Submit"}
									</Button>
								</Col>
							</Row>
						</Form>
					</div>
				</Container>
			</div>
		</>
	);
};

export default Home;
